/* --------------------------------------------------
 *  src/config/api.js  –  central place for API origin
 * -------------------------------------------------- */

// Normalise env var – empty string in dev keeps paths relative
const RAW = (process.env.REACT_APP_API_URL || "").trim();
export const API_BASE = RAW.endsWith("/") ? RAW.slice(0, -1) : RAW;

export function apiPath(path = "") {
  if (!API_BASE) return path;                // dev → relative
  const needsSlash = path.startsWith("/");
  return `${API_BASE}${needsSlash ? "" : "/"}${path}`;
}

// Convenience specifically for image proxy URLs
export function proxyImageUrl(imageId, userId) {
  return apiPath(`/api/v1/images/${imageId}/file?userId=${userId}`);
}